<div class="w-full max-w-6xl m-8 bg-white">
    <div class="flex-auto">
        <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 md:px-8 border-b">
            <div>
                <div class="text-4xl font-extrabold tracking-tight leading-none">
                    @if (stateList) {
                        Frátektir Azure umhverfa
                    }
                    @if (stateAdd) {
                        Taka frá {{ selectedEnvironment | uppercase }}
                        <mat-icon
                            matTooltip="Loka"
                            (click)="cancelAdd()"
                            class="icon-size-8 hover:cursor-pointer float-right"
                            svgIcon="heroicons_outline:x"
                        ></mat-icon>
                    }
                </div>
            </div>
            @if (stateList) {
                <div class="flex items-center gap-4 mt-4 sm:mt-0 md:mt-4">
                    <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript w-36">
                        <mat-select [(ngModel)]="selectedEnvironment" (selectionChange)="onEnvironmentChange()">
                            <mat-option [value]="environments.DEV">DEV</mat-option>
                            <mat-option [value]="environments.RELEASE">RELEASE</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-flat-button [color]="'primary'" (click)="showAdd()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2 mr-1 hidden md:block">Taka frá</span>
                    </button>
                </div>
            }
        </div>

        @if (stateAdd) {
            <app-azure-environment-reservations-add
                [selectedEnvironment]="selectedEnvironment"
                (save)="onSave($event)"
                (cancel)="cancelAdd()"
            ></app-azure-environment-reservations-add>
        }

        @if (stateList) {
            <app-azure-environment-reservations-list
                [reservations]="reservations"
                [selectedEnvironment]="selectedEnvironment"
                (deleteClicked)="onDelete($event)"
            ></app-azure-environment-reservations-list>
        }
    </div>
</div>
